var _defs, _circle, _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _line, _line2, _line3, _line4, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLikeSmiley(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f8dc25;}.cls-2{fill:#f2bc0f;}.cls-2,.cls-6{opacity:0.7;}.cls-3,.cls-4{fill:#f85565;}.cls-3{opacity:0.2;}.cls-5,.cls-6{fill:none;stroke:#fff;stroke-linecap:round;}.cls-5{stroke-linejoin:round;stroke-width:2px;}.cls-6{stroke-miterlimit:10;stroke-width:8px;}.cls-7{fill:#393c54;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 58
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53,107A71.65,71.65,0,0,1,16.25,96.91,58,58,0,0,0,121.56,57,72,72,0,0,1,53,107Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 36.63,
    cy: 74.03,
    rx: 10.76,
    ry: 6.03
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 91.67,
    cy: 74.03,
    rx: 10.76,
    ry: 6.03
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M92.17,49.09a9.42,9.42,0,0,0-13.94.69,9.69,9.69,0,0,0,.91,12.92L90.6,74.17a2.22,2.22,0,0,0,3.14,0L105.21,62.7a9.69,9.69,0,0,0,.91-12.92A9.42,9.42,0,0,0,92.17,49.09Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.12,49.09a9.42,9.42,0,0,0-13.94.69,9.69,9.69,0,0,0,.91,12.92L34.55,74.17a2.22,2.22,0,0,0,3.14,0L49.16,62.7a9.69,9.69,0,0,0,.91-12.92A9.42,9.42,0,0,0,36.12,49.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M42.78,50.91a4.94,4.94,0,0,1,1.08.12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,53.43a5.24,5.24,0,0,1-1.11,6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.77,50.91a4.94,4.94,0,0,1,1.08.12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M103,53.43a5.24,5.24,0,0,1-1.11,6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 50,
    x2: 50,
    y1: 99,
    y2: 114
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 46,
    x2: 46,
    y1: 91,
    y2: 109
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 79,
    x2: 79,
    y1: 101,
    y2: 114
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 83,
    x2: 83,
    y1: 97,
    y2: 107
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M83.2,85.29c4.23-2.12,6.34,1.52,6.34,3.39,0,11.43-9.11,20.09-23.27,20.09a27.71,27.71,0,0,1-27.5-24.32c-.23-1.86,1.93-5.14,5.18-3.39C59.18,89.29,73.08,90.35,83.2,85.29Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.26,108.76c6.8,0,12.42-2,16.45-5.36-3.72-4.51-9.64-5.14-16.45-5.14s-12.7.63-16.42,5.11A27.58,27.58,0,0,0,66.26,108.76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeSmiley);
export default __webpack_public_path__ + "static/media/like_smiley.e3bae5a541370caf955d69a2c3a750b1.svg";
export { ForwardRef as ReactComponent };